import { ColumnMetadata, ColumnTypes } from "~/components/DataGrid";
import { Emdash } from "~/components/Punctuation";
import { AssetColumns } from "~/modules/assets/types";
import { getMeasureValue } from "~/utils/getMeasureValue";
import { DataGridNumberPercentChangeComboCell } from "~/components/DataGrid/DataGridNumberPercentChangeComboCell";
import { DataGridDollarPercentChangeComboCell } from "~/components/DataGrid/DataGridDollarPercentChangeComboCell";
import { AssetTableRowData } from "../types";
import { CatalogMetricSlugs } from "~/modules/catalog/types";

// // // //

export const ADJUSTED_DAILY_MINTS_DOLLAR_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.adjustedDailyMintsDollar,
    label: "Adjusted Daily Mints",
    tooltip: CatalogMetricSlugs.adjusted_daily_mints_dollar,
    type: ColumnTypes.number,
    sortsOn: AssetColumns.adjustedDailyMintsDollar,
    width: 200,
    render: (item) => {
        const measure = getMeasureValue(item, "adjusted_daily_mints_dollar");

        if (measure === null) {
            return <Emdash />;
        }

        return (
            <DataGridDollarPercentChangeComboCell
                value={measure.val}
                pct_change_interval="7d"
                pct_change_value={measure.chg_30d_pct}
            />
        );
    },
};

export const ADJUSTED_DAILY_MINTS_TOKEN_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.adjustedDailyMintsToken,
    label: "Adjusted Daily Mints (Token)",
    tooltip: CatalogMetricSlugs.adjusted_daily_mints_token,
    type: ColumnTypes.number,
    sortsOn: AssetColumns.adjustedDailyMintsToken,
    width: 220,
    render: (item) => {
        const measure = getMeasureValue(item, "adjusted_daily_mints_token");

        if (measure === null) {
            return <Emdash />;
        }

        return (
            <DataGridNumberPercentChangeComboCell
                value={measure.val}
                pct_change_interval="7d"
                pct_change_value={measure.chg_30d_pct}
                significantDigits={2}
            />
        );
    },
};

export const ADJUSTED_DAILY_BURNS_DOLLAR_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.adjustedDailyBurnsDollar,
    label: "Adjusted Daily Burns",
    tooltip: CatalogMetricSlugs.adjusted_daily_burns_dollar,
    type: ColumnTypes.number,
    sortsOn: AssetColumns.adjustedDailyBurnsDollar,
    width: 200,
    render: (item) => {
        const measure = getMeasureValue(item, "adjusted_daily_burns_dollar");

        if (measure === null) {
            return <Emdash />;
        }

        return (
            <DataGridDollarPercentChangeComboCell
                value={measure.val}
                pct_change_interval="7d"
                pct_change_value={measure.chg_30d_pct}
            />
        );
    },
};

export const ADJUSTED_DAILY_BURNS_TOKEN_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.adjustedDailyBurnsToken,
    label: "Adjusted Daily Burns (Token)",
    tooltip: CatalogMetricSlugs.adjusted_daily_burns_token,
    type: ColumnTypes.number,
    sortsOn: AssetColumns.adjustedDailyBurnsToken,
    width: 220,
    render: (item) => {
        const measure = getMeasureValue(item, "adjusted_daily_burns_token");

        if (measure === null) {
            return <Emdash />;
        }

        return (
            <DataGridNumberPercentChangeComboCell
                value={measure.val}
                pct_change_interval="7d"
                pct_change_value={measure.chg_30d_pct}
                significantDigits={2}
            />
        );
    },
};

export const DAILY_MINTS_DOLLAR_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.dailyMintsDollar,
    label: "Daily Mints",
    tooltip: CatalogMetricSlugs.daily_mints_dollar,
    type: ColumnTypes.number,
    sortsOn: AssetColumns.dailyMintsDollar,
    width: 180,
    render: (item) => {
        const measure = getMeasureValue(item, "daily_mints_dollar");

        if (measure === null) {
            return <Emdash />;
        }

        return (
            <DataGridDollarPercentChangeComboCell
                value={measure.val}
                pct_change_interval="7d"
                pct_change_value={measure.chg_30d_pct}
            />
        );
    },
};

export const DAILY_MINTS_TOKEN_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.dailyMintsToken,
    label: "Daily Mints (Token)",
    tooltip: CatalogMetricSlugs.daily_mints_token,
    type: ColumnTypes.number,
    sortsOn: AssetColumns.dailyMintsToken,
    width: 200,
    render: (item) => {
        const measure = getMeasureValue(item, "daily_mints_token");

        if (measure === null) {
            return <Emdash />;
        }

        return (
            <DataGridNumberPercentChangeComboCell
                value={measure.val}
                pct_change_interval="7d"
                pct_change_value={measure.chg_30d_pct}
                significantDigits={2}
            />
        );
    },
};

export const DAILY_BURNS_DOLLAR_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.dailyBurnsDollar,
    label: "Daily Burns",
    tooltip: CatalogMetricSlugs.daily_burns_dollar,
    type: ColumnTypes.number,
    sortsOn: AssetColumns.dailyBurnsDollar,
    width: 180,
    render: (item) => {
        const measure = getMeasureValue(item, "daily_burns_dollar");

        if (measure === null) {
            return <Emdash />;
        }

        return (
            <DataGridDollarPercentChangeComboCell
                value={measure.val}
                pct_change_interval="7d"
                pct_change_value={measure.chg_30d_pct}
            />
        );
    },
};

export const DAILY_BURNS_TOKEN_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.dailyBurnsToken,
    label: "Daily Burns (Token)",
    tooltip: CatalogMetricSlugs.daily_burns_token,
    type: ColumnTypes.number,
    sortsOn: AssetColumns.dailyBurnsToken,
    width: 200,
    render: (item) => {
        const measure = getMeasureValue(item, "daily_burns_token");

        if (measure === null) {
            return <Emdash />;
        }

        return (
            <DataGridNumberPercentChangeComboCell
                value={measure.val}
                pct_change_interval="7d"
                pct_change_value={measure.chg_30d_pct}
                significantDigits={2}
            />
        );
    },
};
